export default "__VITE_ASSET__FTpF1v1D__"